import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import IconVerifySuccess from '@src/assets/icons/cancel-icon.svg';
import DialogWithContent from '@src/components/DialogWithContent';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import {
  StyledRequestDialogAction,
  StyledRequestDialogContent,
} from '../index.style';
import { StyledCancelWithdrawalDialogNote } from './index.style';

const CancelWithdrawalRequestDialog = ({
  open,
  onClose,
  onCancelWithdrawalRequest,
  loading,
}) => {
  const { t } = useTranslation();

  const handleClose = async () => {
    onClose();
  };

  const renderContent = () => (
    <StyledRequestDialogContent>
      <StyledCancelWithdrawalDialogNote>
        <WarningRoundedIcon className="note-icon" />
        <Typography className="note-text">
          {t('withdrawalRequestsCannotBeRestoredAfterCancellation')}
        </Typography>
      </StyledCancelWithdrawalDialogNote>
    </StyledRequestDialogContent>
  );

  const renderAction = () => (
    <StyledRequestDialogAction>
      <CommonButton
        onClick={handleClose}
        variant="outlined"
        className="dialog-actions-button"
        sx={{
          height: '40px',
          border: `1px solid ${COLOR.secondary[16]}`,
          padding: '8px 16px',
          borderRadius: '8px',
        }}
        textProps={{
          variantText: 'body-14-medium',
          color: COLOR.indigo.default,
        }}
      >
        {t('back')}
      </CommonButton>
      <CommonButton
        onClick={onCancelWithdrawalRequest}
        variant="contained"
        className="dialog-actions-button"
        sx={{
          height: '40px',
          padding: '8px 16px',
          borderRadius: '8px',
          backgroundColor: COLOR.textRejected,
          '&:hover': {
            backgroundColor: COLOR.textRejected,
            opacity: 0.8,
          },
          '&:focus': {
            backgroundColor: COLOR.textRejected,
          },
        }}
        textProps={{
          variantText: 'body-14-medium',
          color: COLOR.white,
        }}
      >
        {loading ? (
          <CircularProgress
            value={75}
            className="circular-progress"
            size="20px"
          />
        ) : (
          t('cancelRequest')
        )}
      </CommonButton>
    </StyledRequestDialogAction>
  );

  return (
    <DialogWithContent
      image={IconVerifySuccess}
      title={t('cancelWithdrawalRequest')}
      actionComponent={renderAction()}
      open={open}
      onClose={onClose}
      contentPopup={renderContent()}
    />
  );
};

export default CancelWithdrawalRequestDialog;
